// Feature flags and app configuration
export const featureFlags = {
  coachEnabled: false,
  notesEnabled: false,
  slotMachineEnabled: true,
  paywallDay: 4
};

export const appConfig = {
  subscriptionPrice: 19,
  slotMachineWinChance: 0.01, // 1/100
  day1Duration: '10-15 min'
};
